import React, { useMemo } from "react";
import { useAppContext } from "../../../../lib/appContext";
import { LandingData, LandingQuery } from "../../../../queries/landing/LandingQuery";
import { LandingTitleContext } from "./";
import { getConfig } from "./helpers/getConfig";
import { useRouter } from "../../../../lib/routerContext";

interface IProviderProps {
  landingName: string;
}

interface IBaseProviderProps extends LandingData, Pick<IProviderProps, "landingName"> {
  businessUnitConfig: any;
  loading: boolean;
}

const BaseProvider: React.FC<IBaseProviderProps> = ({
  landing,
  businessUnitConfig,
  landingName,
  children,
  loading
}) => {
  const config = useMemo(() => getConfig(landing || {}, businessUnitConfig, landingName), [
    landing,
    loading
  ]);
  return <LandingTitleContext.Provider value={config}>{children}</LandingTitleContext.Provider>;
};

export const LandingTitleContextProvider: React.FC<IProviderProps> = ({
  children,
  landingName
}) => {
  const { businessUnitSlug, countryCode, businessUnitConfig } = useAppContext();
  const router = useRouter();
  return (
    <LandingQuery
      variables={{
        businessUnitInput: {
          countryCode,
          slug: businessUnitSlug
        },
        path: router && router.asPath ? router.asPath : ""
      }}
    >
      {({ loading, error, data }) => {
        if (error || !data) {
          throw error;
        }
        return (
          <BaseProvider
            businessUnitConfig={businessUnitConfig}
            landing={data.landing}
            landingName={landingName}
            loading={loading}
          >
            {children}
          </BaseProvider>
        );
      }}
    </LandingQuery>
  );
};
